import { Component, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { UserPsychologistService } from '../../services/user-psychologist.service';
import { UserPsychologist } from '../../models/user-psychologist';
import { Psychologist } from '../../models/psychologists';
import { PsychologistService } from '../../services/psychologist.service';
import { User } from '../../models/user';
import { HeaderComponent } from '../../components/header/header.component';
import { MatIcon } from '@angular/material/icon';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { TranslatePipe } from '@ngx-translate/core';
import { PhoneNumberPipe } from '../../pipes/phone-number.pipe';

@Component({
  selector: 'app-patient-list',
  imports: [
    HeaderComponent,
    MatIcon,
    TranslatePipe,
    PhoneNumberPipe
  ],
  templateUrl: './patient-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './patient-list.component.scss',
})
export class PatientListComponent {

  authService: AuthService = inject(AUTH_SERVICE);
  psychologistService: PsychologistService<Psychologist> = inject(PsychologistService<Psychologist>);
  userPsychologistService: UserPsychologistService<UserPsychologist> = inject(UserPsychologistService<UserPsychologist>);
  patients: WritableSignal<User[]> = signal<User[]>([]); 

  constructor(){
    const psychologistId = this.psychologistService.psychologist()?.id;
    
    if(psychologistId){
      this.getPatients(psychologistId);
    }else{
      this.psychologistService.getPsychologistByUserId(this.authService.user()?.id || '').then(
      (psychologist) => {
        const psychologistId = psychologist?.id;
        if(psychologistId){
          this.getPatients(psychologistId);
        }
      });
    }
  }

  back(){
    history.back();
  }

  getPatients(psychologistId: string){
    this.userPsychologistService.getAllActiveUsersPsychologistsByPsychologistId(psychologistId).then(
      (data) => {
        if(data){
          for(let userPsychologist of data){
            let activeUser = userPsychologist.users;
            if(activeUser){
              this.patients.update(
                (current) => {
                  return [...current, activeUser].sort((a, b) => (a.first_name || '').localeCompare((b.first_name || '')));
                }
              )
            }
          }
        }
      }
    );
  }

}
